import { render } from "./HomeLandPage.vue?vue&type=template&id=2385aa21"
import script from "./HomeLandPage.vue?vue&type=script&lang=js"
export * from "./HomeLandPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__